import { $ } from "@/common/Axios";

export default {
  /**
   * 弘诚平台作业
   */
  hcHomework_createHcHomework: {
    /*
     * 创建弘诚平台作业
     * siteId 学校id (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/hcHomework/createHcHomework", p, c),
  },
  hcHomework_createOneHomework: {
    /*
     * 创建弘诚平台作业（单个）
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/hcHomework/createOneHomework", p, c),
  },
  hcHomework_downloadHomework: {
    /*
     * 下载作业
     * courseId 课程id (string query )
     * homeworkId 作业id (string query )
     * majorId 专业id (integer query required)
     * rollGrade 学籍年级 (string query required)
     * siteId 学校id (string query required)
     * term 学期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/hcHomework/downloadHomework", p, c),
  },
  hcHomework_list: {
    /*
     * 列表
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/hcHomework/list", p, c),
  },
  hcHomework_listCourse: {
    /*
     * 获取课程
     * majorId 专业id (integer query required)
     * rollGrade 学籍年级 (string query required)
     * siteId 学校id (string query required)
     * term 学期 (string query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/hcHomework/listCourse", p, c),
  },

  /**
   * 杭商院作业记录
   */
  hsyWorkRecord: {
    /*
     * 添加
     * examCookie 考试cookie (string query )
     * id  (integer query )
     * loginCookie 登录cookie (string query )
     * remark  (string query )
     * status 状态（未开始、登录成功、登录失败、作业中，完成） (string query )
     * times 作业次数 (integer query )
     * userName 用户名 (string query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/hsyWorkRecord", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/hsyWorkRecord", p, c),
  },
  hsyWorkRecord_exportWord: {
    /*
     * 导出word
     * id 课程列表ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/hsyWorkRecord/exportWord", p, c),
  },
  hsyWorkRecord_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/hsyWorkRecord/list", p, c),
  },
  hsyWorkRecord_listCourse: {
    /*
     * 课程列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/hsyWorkRecord/listCourse", p, c),
  },
  hsyWorkRecord_listRecord: {
    /*
     * 做题记录列表
     * id 课程列表返回的id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/hsyWorkRecord/listRecord", p, c),
  },
  hsyWorkRecord_removeCourse: {
    /*
     * 删除课程
     * id 课程列表id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/hsyWorkRecord/removeCourse", p, c),
  },
  hsyWorkRecord_removeRecord: {
    /*
     * 删除记录
     * id 记录列表id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/hsyWorkRecord/removeRecord", p, c),
  },
  hsyWorkRecord_start: {
    /*
     * 开始作业
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/hsyWorkRecord/start", p, c),
  },

  /**
   * 计量学生章节情况
   */
  jiliangStudentChapter: {
    /*
     * 添加或者编辑
     * chapterName 章节名字 (string query )
     * courseName 课程名字 (string query )
     * id  (integer query )
     * liveId 直播id (string query )
     * liveInfo 直播信息 (string query )
     * liveInfoUrl 直播信息地址 (string query )
     * liveStatus 状态 (string query )
     * liveUpdateUrl 直播更新地址 (string query )
     * percentValue 直播进度 (number query )
     * schoolRollId 学籍id (integer query )
     * term 学期 (string query )
     * userId 用户id (string query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jiliangStudentChapter", p, c),
  },
  jiliangStudentChapter_syncChapters: {
    /*
     * 同步章节信息
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jiliangStudentChapter/syncChapters", p, c),
  },

  /**
   * 经济学生试卷
   */
  jingjiPaper: {
    /*
     * 添加
     * id id (integer query )
     * name 名称 (string query required)
     * rollGrade 学籍年级 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiPaper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/jingjiPaper", p, c),
  },
  jingjiPaper_exportRecord: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiPaper/exportRecord", p, c),
  },
  jingjiPaper_finishPaper: {
    /*
     * 生成学生试卷
     * id id, 试卷列表的ID (integer query )
     * reCreate 是否重新生成 (string query required)
     * recordIds 记录列表的ID多选 (array query )
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiPaper/finishPaper", p, c),
  },
  jingjiPaper_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiPaper/list", p, c),
  },
  jingjiPaper_listRecord: {
    /*
     * 记录列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiPaper/listRecord", p, c),
  },
  jingjiPaper_removeRecord: {
    /*
     * 批量删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiPaper/removeRecord", p, c),
  },

  /**
   * 经职院作业
   */
  jingjiWork: {
    /*
     * 添加
     * endTime 结束时间 (string query required)
     * id id (integer query )
     * majorIds 专业（多选） (array query )
     * rollGrade 学籍年级 (string query required)
     * startTime 开始时间 (string query required)
     * theme 主题 (string query required)
     * title 题目 (string query required)
     * type 经济作业类型 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiWork", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/jingjiWork", p, c),
  },
  jingjiWork_checkReference: {
    /*
     * 查看模板效果
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiWork/checkReference", p, c),
  },
  jingjiWork_exportRecord: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/exportRecord", p, c),
  },
  jingjiWork_exportSignature: {
    /*
     * 导出学生签名
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiWork/exportSignature", p, c),
  },
  jingjiWork_finishWork: {
    /*
     * 生成学生作业
     * id id (integer query )
     * reCreate 是否重新生成 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiWork/finishWork", p, c),
  },
  jingjiWork_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/list", p, c),
  },
  jingjiWork_listRecord: {
    /*
     * 学习记录列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/listRecord", p, c),
  },
  jingjiWork_listReference: {
    /*
     * 范文列表
     * id id (integer query required)
     * type 类型：试卷或作业或实训报告 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiWork/listReference", p, c),
  },
  jingjiWork_listSignature: {
    /*
     * 学生签名列表
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiWork/listSignature", p, c),
  },
  jingjiWork_removeRecord: {
    /*
     * 批量删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiWork/removeRecord", p, c),
  },
  jingjiWork_removeReference: {
    /*
     * 删除范文
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiWork/removeReference", p, c),
  },
  jingjiWork_saveReference: {
    /*
     * 添加范文
     * content 正文 (string query )
     * id  (integer query )
     * title 标题 (string query )
     * type 类型：作业或试卷或实训报告 (string query )
     * workId 作业ID (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiWork/saveReference", p, c),
  },

  /**
   * 学校学习情况
   */
  siteStudy_batchSync: {
    /*
     * 批量同步
     * siteId 学校id (string query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/siteStudy/batchSync", p, c),
  },
  siteStudy_check: {
    /*
     * 登记
     * account 账号 (string query )
     * cookie cookie (string query )
     * id 行id (integer query required)
     * imageCode 经济登记时传验证码, 没传验证码的默认为客户端登记 (string query )
     * loginInfo 登录信息 (string query )
     * password 密码 (string query )
     * userId 用户id(计量) (string query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/siteStudy/check", p, c),
  },
  siteStudy_clearCheck: {
    /*
     * 清空登记
     * id 行id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/siteStudy/clearCheck", p, c),
  },
  siteStudy_exportJingji: {
    /*
     * 导出-经济
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/exportJingji", p, c),
  },
  siteStudy_fail: {
    /*
     * 失败
     * errorMsg 错误信息 (string query required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/siteStudy/fail", p, c),
  },
  siteStudy_getHongchengLonginInfo: {
    /*
     * 获取弘诚平台登录信息
     * siteId 学校id (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/siteStudy/getHongchengLonginInfo", p, c),
  },
  siteStudy_getStudyConfig: {
    /*
     * 获取配置
     * siteId 学校id (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/siteStudy/getStudyConfig", p, c),
  },
  siteStudy_getValidationCode: {
    /*
     * 下载验证码, 经济刷课登记
     * account 登记的账号 (string query required)
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/siteStudy/getValidationCode", p, c),
  },
  siteStudy_init: {
    /*
     * 初始化学校学习情况
     * siteId 学校id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/siteStudy/init", p, c),
  },
  siteStudy_listChecked: {
    /*
     * 获取已登记的学生
     * siteId 学校id (string query required)
     * syncStatuses 同步状态 (array query )
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listChecked", p, c),
  },
  siteStudy_listGongshang: {
    /*
     * 工商学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listGongshang", p, c),
  },
  siteStudy_listHd: {
    /*
     * 湖北大学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listHd", p, c),
  },
  siteStudy_listHsy: {
    /*
     * 杭商院学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listHsy", p, c),
  },
  siteStudy_listJiliang: {
    /*
     * 计量学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listJiliang", p, c),
  },
  siteStudy_listJingji: {
    /*
     * 经济职业学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listJingji", p, c),
  },
  siteStudy_listLigong: {
    /*
     * 理工学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listLigong", p, c),
  },
  siteStudy_listShangye: {
    /*
     * 商职学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listShangye", p, c),
  },
  siteStudy_listXgd: {
    /*
     * 西工大学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listXgd", p, c),
  },
  siteStudy_setManualUser: {
    /*
     * 设置为手动用户
     * id id (integer query required)
     * manualUser 是否为手动用户 (string query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/siteStudy/setManualUser", p, c),
  },
  siteStudy_setStudyConfig: {
    /*
     * 设置配置
     * config 配置json (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/siteStudy/setStudyConfig", p, c),
  },
  siteStudy_study: {
    /*
     * 学习
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/siteStudy/study", p, c),
  },
  siteStudy_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/siteStudy/sync", p, c),
  },
  siteStudy_syncHongchengCookie: {
    /*
     * 同步弘诚平台cookie
     * cookie cookie (string query required)
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/siteStudy/syncHongchengCookie", p, c),
  },

  /**
   * 学校学习情况详情
   */
  siteStudyDetail_updateFromClient: {
    /*
     * 客户端同步结果-经济
     * errorMsg 错误信息 (string query )
     * firstFinishCount firstFinishCount (integer query required)
     * firstNeedCount firstNeedCount (integer query required)
     * id id (integer query required)
     * secondFinishCount secondFinishCount (integer query required)
     * secondNeedCount secondNeedCount (integer query required)
     * studyDetail studyDetail (string query )
     * syncStatus syncStatus (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/siteStudyDetail/updateFromClient", p, c),
  },
};
